import { createValidator, maxLength, required } from 'util/validation'

import { CadastrarSalaPainelChamadasModel } from '../model-chamadaPainel'

export const cadastrarSalaPainelValidator = createValidator<CadastrarSalaPainelChamadasModel>({
  nome: [required, maxLength(50)],
})
